import { render } from "./SeolbiAlimtalkTracking.vue?vue&type=template&id=33d6ff08&scoped=true"
import script from "./SeolbiAlimtalkTracking.vue?vue&type=script&lang=js"
export * from "./SeolbiAlimtalkTracking.vue?vue&type=script&lang=js"

import "./SeolbiAlimtalkTracking.vue?vue&type=style&index=0&id=33d6ff08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d6ff08"]])

export default __exports__